import { SnapShotRef, TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"
import {
  processActionMeta,
  getArrayTypeReducerGuard
} from "../reducers"

export type SnapRef = {
  id: string
  versions: Array<SnapShotRef>
  thumbnail: string
}

const reducerAction = {
  id: actionCreatorTypeGuard<SnapRef, string>("id", "SnapRef"),
  thumbnail: actionCreatorTypeGuard<SnapRef, string>("thumbnail", "SnapRef"),
  versions: actionCreatorTypeGuard<SnapRef, Array<SnapShotRef>>(
    "versions",
    "SnapRef"
  ),
  __record: actionCreatorTypeGuard<TypeArray, SnapRef>("SnapRef", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<SnapRef>>(
    "create",
    "__create/SnapRef"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof SnapRef
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const snapRefAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const snapRefReducer = reducerTypeGuard<SnapRef>()
  .case(...reducerAction.id)
  .case(...reducerAction.thumbnail)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "versions":
        return getArrayTypeReducerGuard<SnapRef, SnapShotRef>(
          "snapRef",
          "versions",
          "SnapShotRef",
          prevState,
          action
        )
    }

    return prevState
  })
